import React from 'react';
import './styles.scss';

import { logout } from '../../common/utils/pkce';

import { Button } from 'antd';
import { Logo } from '../../components';
import { ReactComponent as IconClearHouse } from '../../assets/svg/icon_clearing_house.svg';
import { ReactComponent as WfpLogo } from '../../assets/svg/agencies/wfp-logo.svg';

const Header: React.FC = () => {
  const onLogoutHandler = (): void => {
    logout();
  };

  return (
    <section className='header'>
      <Logo />
      <div></div>
      <div className='status-bar'>
        <div className='status-container'>
          <WfpLogo height='100%' width='50px' />
          <span>
            Hello <b>{localStorage.getItem('username')}</b>,
            <Button type='link' onClick={onLogoutHandler}>
              Logout
            </Button>
          </span>
        </div>
      </div>
    </section>
  );
};

export default Header;
